var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoSearchResultsIcon = function SvgNoSearchResultsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 52,
    fill: "none",
    viewBox: "0 0 56 52"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.538,
    cy: 25.038,
    r: 24.038,
    fill: "#E5E5FE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.865,
    cy: 26,
    r: 22.115,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m54.771 51-9.3-9.84a21.817 21.817 0 1 0-8.952 5.596"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeLinecap: "round",
    d: "M23.139 20.637 35.79 33.29M35.791 20.637 23.14 33.29"
  })));
};
export default SvgNoSearchResultsIcon;